import {ButtonProps, Button} from '@eds-web/react';
import {useLocale} from '@epic-mw/i18n';
import {useState} from 'react';
import {EulaModal} from '../eula';
import {AnalyticEventProps} from '@/types';

interface ConfirmEulaButtonProps extends ButtonProps {
	eulaId: string;
	eulaVersion: number;
	onDecline?: (e) => void;
	onAccept?: (e) => void;
	onAcceptSuccessful?: (e) => void;
	analytics?: AnalyticEventProps;
}

export const ConfirmEulaButton = ({
	eulaId,
	eulaVersion,
	onAcceptSuccessful,
	onAccept,
	onDecline,
	onClick,
	analytics,
	...buttonProps
}: ConfirmEulaButtonProps) => {
	const [open, setOpen] = useState(false);
	const locale = useLocale();
	const formattedLocale = locale === 'en-US' ? locale.split('-')[0] : locale;

	return (
		<>
			<Button
				{...buttonProps}
				type="button"
				onClick={(e) => {
					setOpen(true);
					onClick?.(e);
				}}
			/>
			{open && (
				<EulaModal
					open={open}
					eulaId={eulaId}
					version={eulaVersion}
					analytics={analytics}
					locale={formattedLocale}
					onAccept={onAccept}
					onAcceptSuccessful={onAcceptSuccessful}
					onClose={(e) => {
						setOpen(false);
						onDecline?.(e);
					}}
				/>
			)}
		</>
	);
};
